/**
 * appConfig.js — Helper centralizado de configuración
 * ============================================================
 * Lee window.__APP_CONFIG__ (cargado desde public/config.js en
 * runtime) con fallback a variables de entorno del .env y luego
 * a valores por defecto hardcodeados.
 *
 * Orden de prioridad:
 *   1. window.__APP_CONFIG__  (config.js en servidor — sin recompilar)
 *   2. process.env.REACT_APP_* (variables del .env — requiere rebuild)
 *   3. Valor por defecto       (para desarrollo local)
 * ============================================================
 */

const cfg = window.__APP_CONFIG__ || {};

export const AppConfig = {

  /* ── API principal ──────────────────────────────────────── */
  API_BASE_URL: cfg.API_BASE_URL
    || process.env.REACT_APP_API_BASE_URL
    || "http://172.20.11.28:7025",

  /* ── Sesión / Auth ──────────────────────────────────────── */
  SESION_CHECK_URL: cfg.SESION_CHECK_URL
    || process.env.REACT_APP_SESION_CHECK_URL
    || "https://dimici.produce.gob.pe/SigiProdMici/GetEstado",

  LOGIN_URL_BASE: cfg.LOGIN_URL_BASE
    || process.env.REACT_APP_LOGIN_URL_BASE
    || "https://delogin.produce.gob.pe/auth/login/person",

  LOGIN_APP_ID: cfg.LOGIN_APP_ID
    || process.env.REACT_APP_LOGIN_APP_ID
    || "297",

  PORTAL_URL: cfg.PORTAL_URL
    || process.env.REACT_APP_PORTAL_URL
    || "https://desistemasv2.produce.gob.pe/#/funcionarios",

  LOGOUT_URL: cfg.LOGOUT_URL
    || process.env.REACT_APP_LOGOUT_URL
    || "https://desistemasv2.produce.gob.pe/inicio/ExternalLogOut",

  /* ── Imágenes estáticas ─────────────────────────────────── */
  MEDIA_BASE_URL: cfg.MEDIA_BASE_URL
    || process.env.REACT_APP_MEDIA_BASE_URL
    || "https://dimici.produce.gob.pe",

  /* ── Capas ArcGIS ───────────────────────────────────────── */
  PARQUES_INDUSTRIALES: cfg.PARQUES_INDUSTRIALES
    || process.env.REACT_APP_PARQUES_INDUSTRIALES
    || "https://dimici.produce.gob.pe/arcgis/rest/services/pndp/parques_industriales/MapServer",

  ZONAS_INDUSTRIALES: cfg.ZONAS_INDUSTRIALES
    || process.env.REACT_APP_ZONAS_INDUSTRIALES
    || "https://dimici.produce.gob.pe/arcgis/rest/services/industrias/zonas_industriales/MapServer",

  DEPARTAMENTO: cfg.DEPARTAMENTO
    || process.env.REACT_APP_DEPARTAMENTO
    || "https://dimici.produce.gob.pe/arcgis/services/pndp/departamento/MapServer/WMSServer",

  DEPARTAMENTO_WFS: cfg.DEPARTAMENTO_WFS
    || process.env.REACT_APP_DEPARTAMENTO_WFS
    || "https://dimici.produce.gob.pe/arcgis/rest/services/pndp/departamento/MapServer",

  BASE_CHANCAY: cfg.BASE_CHANCAY
    || process.env.REACT_APP_BASE_CHANCAY
    || "https://dimici.produce.gob.pe/arcgis/services/pndp/chancay/MapServer/WMSServer",

  BASE_ATRACTORES: cfg.BASE_ATRACTORES
    || process.env.REACT_APP_BASE_ATRACTORES
    || "https://dimici.produce.gob.pe/arcgis/services/pndp/Atractores/MapServer/WMSServer",

  BASE_CORREDORES: cfg.BASE_CORREDORES
    || process.env.REACT_APP_BASE_CORREDORES
    || "https://dimici.produce.gob.pe/arcgis/services/pndp/Corredores/MapServer/WMSServer",

  /* ── Tiles de mapa base (Leaflet TileLayer) ─────────────── */
  TILE_CARTO_LIGHT: cfg.TILE_CARTO_LIGHT
    || process.env.REACT_APP_TILE_CARTO_LIGHT
    || "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",

  TILE_CARTO_DARK: cfg.TILE_CARTO_DARK
    || process.env.REACT_APP_TILE_CARTO_DARK
    || "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png",

  TILE_OSM: cfg.TILE_OSM
    || process.env.REACT_APP_TILE_OSM
    || "https://tile.openstreetmap.org/{z}/{x}/{y}.png",

  TILE_TOPO: cfg.TILE_TOPO
    || process.env.REACT_APP_TILE_TOPO
    || "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",

  TILE_ESRI_SAT: cfg.TILE_ESRI_SAT
    || process.env.REACT_APP_TILE_ESRI_SAT
    || "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",

  /* ── Router ─────────────────────────────────────────────── */
  BASENAME: cfg.BASENAME
    || process.env.REACT_APP_BASENAME
    || "/",
};
